module.exports = __webpack_public_path__ + "img/fingerprint-six.dbb72b2a.svg";